import shuffleArray from '@/services/shuffleArray'

export const baseGetters = {
    currentArticle: state => data => state.articles.find((article) => (article.slug == `article/${data}`)),
    shuffled: state => shuffleArray(state.articles).filter((item, index) => index < 3),
    getArticles: state => state.articles.filter((item, index) => index < 3)
    // cartItemAmount: state => (cartItem) => {
    //     return (Math.ceil(state.userCart[cartItem].menu.qty * state.userCart[cartItem].menu.amount * 100) / 100).toFixed(2)
    // }
}